import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStaffService } from '../../../../apis/staff/useStaffService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TStaffListApiResponse } from '../../../../apis/staff/staff.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStaffListKey = 'get-staff-list';

export const useStaffListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TStaffListApiResponse, TQueryError>
): UseQueryResult<TStaffListApiResponse, TQueryError> => {
  const { getStaffList } = useStaffService();

  return useQuery<TStaffListApiResponse, TQueryError>({
    queryKey: [getStaffListKey, params],
    queryFn: () => getStaffList(params),
    enabled: true,
    ...options,
  });
};
